import React from "react";
import Spinner from "react-bootstrap/Spinner";
import * as theme from "../../theme";
import CloudDoneIcon from "@material-ui/icons/CloudDone";
const CloudIcon = ({ isUpdating }) => {
  return (
    <div
      style={{
        marginLeft: "10px",
        marginTop: isUpdating ? "5px" : "0px",
        display: "flex",
      }}
    >
      {isUpdating ? (
        <Spinner animation="border" size="sm" variant="success" />
      ) : (
        <div>
          <CloudDoneIcon
            style={{
              color: theme.COLORS.dark_green_dot,
              fontSize: theme.SCALES.cloudIconSize,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default CloudIcon;
